import { NAME } from './constants';

export default {
  FETCH: `${NAME}/FETCH`,
  FETCHED: `${NAME}/FETCHED`,
  FETCHING: `${NAME}/FETCHING`,
  FAILED: `${NAME}/FAILED`,
  UPDATE_DISTANCE: `${NAME}/UPDATE_DISTANCE`,
  UPDATE_DURATION: `${NAME}/UPDATE_DURATION`,
  UPDATE_STATUS: `${NAME}/UPDATE_STATUS`,
  UPDATE_LOCATION: `${NAME}/UPDATE_LOCATION`,
  REPLACE_SHIPMENTS: `${NAME}/REPLACE_SHIPMENTS`,
  FETCH_SHIPMENT_WAYBILL: `${NAME}/FETCH_SHIPMENT_WAYBILL`,
  FETCHED_SHIPMENT_WAYBILL: `${NAME}/FETCHED_SHIPMENT_WAYBILL`,
  MARK_LOADED: `${NAME}/MARK_LOADED`,
  REQUEST_BULK_ADDRESS_UPDATE: `${NAME}/REQUEST_BULK_ADDRESS_UPDATE`,
  START_REQUEST_BULK_ADDRESS_UPDATE: `${NAME}/START_REQUEST_BULK_ADDRESS_UPDATE`,
  FINISH_REQUEST_BULK_ADDRESS_UPDATE: `${NAME}/FINISH_REQUEST_BULK_ADDRESS_UPDATE`,

  ASSIGN_ORDERS: `${NAME}/ASSIGN_ORDERS`,
  ASSIGNED_ORDERS: `${NAME}/ASSIGNED_ORDERS`,
  TOGGLE_ASSIGN_ORDERS_SCREEN: `${NAME}/TOGGLE_ASSIGN_ORDERS_SCREEN`,

  TOGGLE_SHIPMENT_IN_REASSIGN: `${NAME}/TOGGLE_SHIPMENT_IN_REASSIGN`,

  GENERATE_OTP: `${NAME}/GENERATE_OTP`,
  GENERATED_OTP: `${NAME}/GENERATED_OTP`,
  CANCEL_SHIPMENT: `${NAME}/CANCEL`,
  CANCELLED_SHIPMENT: `${NAME}/CANCELLED_SHIPMENT`,
};
